<!-- CLIENTS LIST PRIMENG DATATABLE -->
<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true" dataKey="name"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{'tableManagement.versions.versionsManagement' | translate}}
    </div>
  </ng-template>

  <!-- TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>


      <!-- VERSION -->
      <th pSortableColumn="name">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.name' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="name"></p-sortIcon>
            <p-columnFilter field="name" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- BRAND -->
      <th pSortableColumn="model.brand.name">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.brands.brand' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="model.brand.name"></p-sortIcon>
            <p-columnFilter field="brand" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- MODEL -->
      <th pSortableColumn="model.name">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.models.model' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="model.name"></p-sortIcon>
            <p-columnFilter field="model" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- CYLINDER CAPACITY -->
      <th pSortableColumn="cylinderCapacity">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.displacement' | translate}}

          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="cylinderCapacity"></p-sortIcon>
            <p-columnFilter field="cylinderCapacity" type="numeric" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- CONSUMPTION -->
      <th pSortableColumn="consumption">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.consumption' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="consumption"></p-sortIcon>
            <p-columnFilter field="consumption" type="numeric" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- EMISSIONS -->
      <th pSortableColumn="emissions">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.emissions' | translate}}

          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="emissions"></p-sortIcon>
            <p-columnFilter field="emissions" type="numeric" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- FUEL CAPACITY -->
      <th pSortableColumn="fuelCapacity">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.fuelCapatity' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="fuelCapacity"></p-sortIcon>
            <p-columnFilter field="fuelCapacity" type="numeric" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- FUEL TYPE -->
      <th pSortableColumn="fuelType">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.fuelType' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <!-- COLUMN FILTER -->
          <div class="d-flex align-items-center h-100">
            <p-columnFilter field="fuelType" type='text' matchMode="contains" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-multiSelect [ngModel]="value" [options]="optionsfuelType"
                placeholder="{{ 'general.search' | translate }}" (onChange)="filter($event.value)"></p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </div>
        </div>
      </th>

      <!-- VERSION -->
      <th pSortableColumn="observations">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{'tableManagement.versions.observations' | translate}}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="observations"></p-sortIcon>
            <p-columnFilter field="observations" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn="disabled">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="disabled"></p-sortIcon>
            <p-columnFilter field="disabled" type="boolean" display="menu" [showApplyButton]="false">
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-select [options]="optionsdeleted" placeholder="{{ 'general.search' | translate }}"
                  (onChange)="filter($event.value)">
                  <ng-template let-option pTemplate="item">
                    <span [ngClass]="'p-ml-1 state-' + option.value">
                      {{ option.label }}
                    </span>
                  </ng-template>
                </p-select>
              </ng-template>
            </p-columnFilter>
          </div>

        </div>
      </th>


    </tr>
  </ng-template>

  <!-- TABLE BODY -->
  <ng-template pTemplate="body" let-version>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(version)">

      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="version"></p-tableCheckbox>
        </div>
      </td>

      <!-- NAME -->
      <td>
        {{version.name}}
      </td>

      <td>
        {{version.model.brand.name}}
      </td>

      <!-- MODEL -->
      <td>
        {{version.model.name}}
      </td>

      <td>
        {{version.cylinderCapacity}} cc
      </td>

      <td>
        {{version.consumption}} l/100km
      </td>

      <td>
        {{version.emissions}} g/km
      </td>

      <td>
        {{ version.fuelCapacity }} l
      </td>

      <td>
        {{ 'tableManagement.fuelType.' + version.fuelType | translate }}
      </td>

      <td>
        {{version.observations}}
      </td>

      <!-- ACTIVE -->
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': !version.disabled, 'false-icon pi-times-circle': version.disabled}"></i>
        </div>
      </td>
    </tr>

  </ng-template>

  <!-- TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="11" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
          {{ 'table.tableEmptyMessage' | translate }}!
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="11" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD CLIENT BUTTON -->
          <app-table-add-button [text]=" 'tableManagement.versions.version' | translate "
            [isDisabled]="!canCreate"
            (btnClick)="create()"></app-table-add-button>

          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
            [isDisabled]="selectedEntities.length === 0 || !canDisable"></app-table-change-status-button>

          <!-- EXCEL BUTTON -->
          <app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>

<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
  <div>
    <app-change-status-shared [items]=" 'tableManagement.versions.versions' | translate " [display]="true"
      [service]=vehicleVersionService [entitiesList]=selectedEntities (return)="refreshList($event)"
    (close)="closeStatusDialog($event)"></app-change-status-shared>
  </div>
}

<!-- VEHICLE VERSION FORM -->
<app-vehicle-version-form [optionsFuelType]="optionsfuelType"></app-vehicle-version-form>